
import moment from "moment";


/**
 * @classdesc Tarif d'une course
 * @kind class
 * @export
 * @prop {int} id - id du tarif
 * @prop {int} id_course - Id de la course
 * @prop {string} nom - Nom du tarif
 * @prop {int} prix - Prix du tarif
 * @prop {int} max_inscrits - Nombre de place disponibles à ce tarif
 * @prop {array} metadatas - Métadonnées du tarif
 *  * @class Tarif_Course
 */
export class Tarif_Course {
    id;
    id_course;
    nom;
    prix;
    max_inscrits;
    nb_inscrits;
    nb_reservations;
    metadatas;
    /**
     * Creates an instance of Tarif_Course.
     * @constructs
     * @kind function
     * @memberof Tarif_Course
     */
    constructor() { }



    set(data) {
        for (const [key, value] of Object.entries(data)) {
            if (this.hasOwnProperty(key)) {
                this[key] = value;
            }
        }
    }

    get_default_price() {
        let prix = parseFloat(this.prix);
        let possible_majoration_price = this.get_majoration_price();
        prix = Math.max(prix, possible_majoration_price);
        return prix;
    }

    has_majorations() {
        let majorations_metadatas = this.metadatas.filter(metadata => metadata.nom.startsWith("majoration_"));
        return majorations_metadatas.length > 0;
    }

    has_upcoming_majoration() {
        let majorations = this.get_majorations();
        for (let i = 0; i < majorations.length; i++) {
            let now = moment();
            let date_majoration = moment(majorations[i].date);
            if (now.isBefore(date_majoration)) {
                return true;
            }
        }
        return false;
    }

    get_majorations() {
        let list_majorations = [];
        let majorations_metadatas = this.metadatas.filter(metadata => metadata.nom.startsWith("majoration_"));
        for (let i = 1; i < 10; i++) {
            let majoration_date_name = "majoration_" + i + "_date";
            let majoration_tarif_name = "majoration_" + i + "_tarif";
            let date = majorations_metadatas.find(majoration => majoration.nom == majoration_date_name);
            let tarif = majorations_metadatas.find(majoration => majoration.nom == majoration_tarif_name);
            if (!date || !tarif) break;
            list_majorations.push({ "date": date.valeur, "tarif": tarif.valeur });
        }
        return list_majorations;
    }

    get_upcoming_majorations() {
        let list_upcoming = [];
        let list_majorations = this.get_majorations();
        for (let i = 0; i < list_majorations.length; i++) {
            let now = moment();
            let date_majoration = moment(list_majorations[i].date);
            if (now.isBefore(date_majoration)) {
                list_upcoming.push(list_majorations[i]);
            }
        }
        return list_upcoming;
    }

    get_majoration_price() {
        let price = 0;
        let majorations = this.get_majorations();

        for (let i = 0; i < majorations.length; i++) {

            let now = moment();
            let date_majoration = moment(majorations[i].date);
            if (now.isAfter(date_majoration) && parseFloat(majorations[i].tarif) > parseFloat(price)) {
                price = majorations[i].tarif;
            }
        }
        return parseFloat(price);
    }

    coureur_match_limitations(limitation, coureur, inscription = null, nom_course = "") {

        switch (limitation.valeur) {
            case "age_max":
                let date_naissance_min = this.get_metadata_by_name("date_naissance_min");
                return (date_naissance_min && coureur.match_limitations(date_naissance_min.nom, date_naissance_min.valeur));
            case "age_min":
                let date_naissance_max = this.get_metadata_by_name("date_naissance_max");
                return (date_naissance_max && coureur.match_limitations(date_naissance_max.nom, date_naissance_max.valeur));
            case "sexe":
                let limitation_sexe = this.get_metadata_by_name("limitation_sexe");
                return (limitation_sexe && coureur.match_limitations(limitation_sexe.nom, limitation_sexe.valeur));
            case "licence":
                return coureur.match_limitations("licence", "licence");
            case "licence_ffrp":
                return coureur.match_limitations("licence_ffrp", "licence_ffrp");
            case "filtre_pass_competition":
                return coureur.match_limitations("filtre_pass_competition", "filtre_pass_competition");
            case "licence_comite_05":
                return coureur.match_limitations("licence_comite_05", "licence_comite_05");
            case "deja_inscrit":
                return coureur.match_limitation_deja_inscrit(inscription);
            case "deja_inscrit_1":
                return coureur.match_limitation_deja_inscrit_1();
            case "deja_inscrit_2":
                return coureur.match_limitation_deja_inscrit_2();
            case "reduction_multiparcours":
                return coureur.match_limitation_reduction_multiparcours(inscription, nom_course);
            case "etudiant":
                return coureur.match_limitations("etudiant", "etudiant");
            default:
                return false;
        }
    }

    has_limitations() {
        let limitation = this.get_metadata_by_name("type_limitation");
        if (!limitation) return false;
        return limitation;
    }

    has_limitation_nb_inscrits() {
        let limitation_groupe_tarif = this.get_metadata_by_name("groupe_max_tarif");
        if (limitation_groupe_tarif) {
            return true;
        }
        return parseFloat(this.max_inscrits) > 0;
    }

    /* Vérifie si il reste une place disponible à ce tarif afin de l'attribuer */
    has_places_disponibles(list_courses) {
        let limitation_groupe_tarif = this.get_metadata_by_name("groupe_max_tarif");
        if (limitation_groupe_tarif) { // Si le tarif a une limitation de groupe

            let current_groupe_tarif = limitation_groupe_tarif.valeur;
            let nb_inscrits_in_groupe = 0;

            for (let i = 0; i < list_courses.length; i++) {
                let course = list_courses[i];
                for (let j = 0; j < course.tarifs.list.length; j++) {
                    let tarif = course.tarifs.list[j];
                    let tarif_limitation_groupe_tarif = tarif.get_metadata_by_name("groupe_max_tarif");
                    if (tarif_limitation_groupe_tarif && tarif_limitation_groupe_tarif.valeur == current_groupe_tarif) {

                        nb_inscrits_in_groupe += parseFloat(tarif.nb_reservations);
                    }
                }
            }

            return nb_inscrits_in_groupe < parseFloat(this.max_inscrits);
        }

        return parseFloat(this.nb_reservations) < parseFloat(this.max_inscrits); // Si le tarif a une limitation de nombre d'inscrits
    }

    has_places_disponibles_with_tarifs(list_tarifs) {
        let limitation_groupe_tarif = this.get_metadata_by_name("groupe_max_tarif");
        if (limitation_groupe_tarif) {

            let current_groupe_tarif = limitation_groupe_tarif.valeur;
            let nb_inscrits_in_groupe = 0;
            for (let i = 0; i < list_tarifs.length; i++) {
                let tarif = list_tarifs[i];
                let tarif_limitation_groupe_tarif = tarif.get_metadata_by_name("groupe_max_tarif");
                if (tarif_limitation_groupe_tarif && tarif_limitation_groupe_tarif.valeur == current_groupe_tarif) {

                    nb_inscrits_in_groupe += parseFloat(tarif.nb_reservations);
                }

            }


            return nb_inscrits_in_groupe < parseFloat(this.max_inscrits);
        }
        return parseFloat(this.nb_reservations) < parseFloat(this.max_inscrits);
    }

    /**
     * Retrieves the limitation based on metadata and returns the corresponding value.
     *
     * @return {string} The limitation value based on specific cases.
     */
    get_limitation() {
        let limitation = this.get_metadata_by_name("type_limitation");
        if (limitation) {
            switch (limitation.valeur) {
                case "age_max":
                    return this.limitation_age_max();
                case "age_min":
                    return this.limitation_age_min();
                case "licence":
                    return "Réservé aux licenciés";
                case 'licence_comite_05':
                    return "Réservé aux licenciés FFA du comité 05";
                case "sexe":
                    return this.limitation_sexe();
                case "deja_inscrit":
                    return "A partir de la deuxième course";
                case "reduction_multiparcours":
                    return "Dans le cas d'une inscription multi parcours";
                default:
                    break;
            }
        }

    }

    limitation_age_max() {
        let date_naissance = this.get_metadata_by_name("date_naissance_min");
        if (date_naissance) {
            return "Né après le " + moment(date_naissance.valeur).format("DD/MM/YYYY");
        }
        return "";
    }
    limitation_age_min() {
        let date_naissance = this.get_metadata_by_name("date_naissance_max");
        if (date_naissance) {
            return "Né avant le " + moment(date_naissance.valeur).format("DD/MM/YYYY");
        }
        return "";
    }

    limitation_sexe() {
        let limitation_sexe = this.get_metadata_by_name("limitation_sexe");
        if (limitation_sexe) {
            if (limitation_sexe.valeur == 'H') {
                return "Réservé aux hommes";
            }
            if (limitation_sexe.valeur == 'F') {
                return "Réservé aux femmes";
            }
            return "Réservé aux " + limitation_sexe.valeur;
        }
    }

    refresh(refreshed_tarif) {
        this.prix = refreshed_tarif.prix;
        this.max_inscrits = refreshed_tarif.max_inscrits;
        this.nb_inscrits = refreshed_tarif.nb_inscrits;
        this.nb_reservations = refreshed_tarif.nb_reservations;
    }

    get_metadata_by_name(name) {
        return this.metadatas.find(metadata => metadata.nom == name);
    }

    is_max_editable() {
        if (this.metadatas.find(metadata => metadata.nom == "groupe_max_tarif")) {
            return false;
        }
        return true;
    }

    update_majorations(majorations) {
        for (let i = 0; i < majorations.length; i++) {
            let majoration_date_name = "majoration_" + (i + 1) + "_date";
            let majoration_tarif_name = "majoration_" + (i + 1) + "_tarif";
            let date = this.metadatas.find(metadata => metadata.nom == majoration_date_name);
            let tarif = this.metadatas.find(metadata => metadata.nom == majoration_tarif_name);
            if (date && tarif) {
                date.valeur = majorations[i].date;
                tarif.valeur = majorations[i].tarif;
            }
        }
    }
}